<template>
  <div id="app">
    <div class="main-content">
      <c-header></c-header>
      <main>
        <transition name="fade" mode="out-in" @after-leave="afterLeave">
          <router-view/>
        </transition>
        <c-location></c-location>
      </main>
      <c-footer></c-footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Location from '@/components/Location.vue'
import _merge from 'lodash/merge'
import { localeChanged } from 'vee-validate'

export default {
  name: 'Hublot-Job-Offers-App',
  components: {
    'c-header': Header,
    'c-footer': Footer,
    'c-location': Location
  },
  methods: {
    afterLeave () {
      this.$root.$emit('triggerScroll')
    }
  },
  watch: {
    // watch for local changes and update current URL
    '$i18n.locale' (val) {
      localeChanged()
      const route = _merge({}, this.$route, { params: { lang: val } })
      this.$router.push(route)
    }
  }
}
</script>

<style lang="scss" src="@/assets/scss/main.scss"></style>

<style lang="scss">
@import '@/assets/scss/_variables.scss';
/**
 * 1. Avoid the IE 10-11 `min-height` bug.
 * 2. Set `flex-shrink` to `0` to prevent some browsers from
 *    letting these items shrink to smaller than their content's default
 *    minimum size. See http://bit.ly/1Mn35US for details.
 * 3. Use `%` instead of `vh` since `vh` is buggy in older mobile Safari.
 */
html, body {
}
#app {
  width:100%;
  min-height: 100vh;
}
.main-content {
  // max-width: 1400px;
  background:white;
  margin: auto;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  .header, .footer {
    flex: none; /* 2 */
  }
  main {
    flex: 1 0 auto; /* 2 */
    background:white;
    max-width: 1400px;
    width:100%;
    margin: auto;
  }
}
</style>
